import { useEffect, useRef } from 'react';
import api from '../utils/api';

const DevWatcher = () => {
  const lastStartTime = useRef(null);

  useEffect(() => {
    // Only run in development
    if (process.env.NODE_ENV !== 'development') return;

    const checkBackend = async () => {
      try {
        // Use the centralized api instance which handles the baseURL correctly
        const response = await api.get('/dev/version');
        const currentStartTime = response.data.startTime;

        if (lastStartTime.current !== null && lastStartTime.current !== currentStartTime) {
          console.log('[DevWatcher] Backend restart detected. Reloading frontend...');
          // Give the backend a moment to fully initialize its routes
          setTimeout(() => {
            window.location.reload();
          }, 500);
        }

        lastStartTime.current = currentStartTime;
      } catch (err) {
        // Backend might be down during restart, that's fine
        // We don't want to log errors to console constantly
      }
    };

    const interval = setInterval(checkBackend, 2000); // Check every 2 seconds
    return () => clearInterval(interval);
  }, []);

  return null;
};

export default DevWatcher;
